export default __webpack_public_path__ + "static/media/system_04_06.c9c644aa.jpg";